import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setWeeklyWorkingHours, signout } from 'features/session/store/actions'
import { handleAPIError, showErrorSnackbar } from 'features/app/store/actions'

const mapStateToProps = state => ({
  user: state.session.user
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setWeeklyWorkingHours, handleAPIError, showErrorSnackbar, signout }, dispatch)
})

export default function wrapper(Component) {
  class SettingsContainer extends PureComponent {
    render() {
      return (
        <Component
          user={this.props.user}
          setWeeklyWorkingHours={this.props.actions.setWeeklyWorkingHours}
          showErrorSnackbar={this.props.actions.showErrorSnackbar}
          handleAPIError={this.props.actions.handleAPIError}
          onLogout={this.props.actions.signout}
        />
      )
    }
  }

  const containerRedux = connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
      pure: true
    }
  )(SettingsContainer)

  return containerRedux
}



// WEBPACK FOOTER //
// ./src/pages/settings/container.js